import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'Matias',
  city: 'Buenos Aires'
}, {
  name: 'Lucía',
  city: 'Córdoba'
}, {
  name: 'Facundo',
  city: 'Rosario'
}, {
  name: 'Julieta',
  city: 'Mendoza'
}, {
  name: 'Diego',
  city: 'Neuquén'
}, {
  name: 'Martín',
  city: 'La Plata'
}, {
  name: 'Sofía',
  city: 'Mar del Plata'
}];
export const SalesPopup = () => {
  const [currentBuyer, setCurrentBuyer] = useState<{
    name: string;
    city: string;
  } | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const interval = setInterval(() => {
      showPopup();
    }, 18000);
    const initialTimeout = setTimeout(showPopup, 5000);
    return () => {
      clearInterval(interval);
      clearTimeout(initialTimeout);
    };
  }, []);
  return <AnimatePresence data-id="element-239">
      {isVisible && currentBuyer && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 z-50 bg-[#112236] border border-[#d4a017]/30 p-3 rounded-lg shadow-xl flex items-center gap-3 max-w-[300px]" data-id="element-240">
          <div className="bg-green-500/20 p-2 rounded-full flex-shrink-0" data-id="element-241">
            <CheckCircle2 className="w-5 h-5 text-green-400" data-id="element-242" />
          </div>
          <div data-id="element-243">
            <p className="text-white text-sm font-medium" data-id="element-244">
              {currentBuyer.name} de {currentBuyer.city}
            </p>
            <p className="text-slate-400 text-xs" data-id="element-245">Acaba de asegurar su cupo</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};